export default __webpack_public_path__ + "static/media/icon-vr360.4d452e2c.svg";